import { Card, Input, Label, Select, II18NValued, Footer, IInputPropertiesBase } from '@2r/frontend-component-library';
import { useState } from 'react';
import { useModul } from '../Hooks/useModul';
import { EnumInterfaceType } from '../model/EnumInterfaceType';
import { VmUser } from '../model/VmUser';

interface IEditProps {
    New?: boolean;
}

function CheckBox(props: IInputPropertiesBase) {
    const [checked, setChecked] = useState<boolean>(props.value || false);

    function changeEvent(e: React.ChangeEvent<HTMLInputElement>) {
        const checked = e.target.checked;

        if (props.onChange !== undefined) {
            props.onChange(checked);
        }

        setChecked(checked);
    }

    return (
        <div className={'col'}>
            <div className={'input-group'}>
                <Label Name={props.Name + "Label"} For={props.Name} Label={props.Label} />
                <input
                    id={props.Name}
                    type="checkbox"
                    checked={checked}
                    onChange={changeEvent}
                />
            </div>
        </div>
    )
}

export function FrameEditUser({ New } : IEditProps) {
    const modul = useModul<VmUser>("/users", "userID", New);
    
    if (modul.isLoading) {
        return <div>Loading...</div>;
    }
    else if (modul.data === undefined) {
        return (
            <div>
                Der Benutzer mit der ID
                {modul.primaryKey}
                konnte nicht geladen werden.
            </div>
        );
    }
    else {
        const user = modul.data;

        const interfaces: II18NValued<number>[] = [
            { Name: "None", Label: "Bitte wählen", Value: EnumInterfaceType.NotDefined },
            { Name: "AVAL", Label: "AvaL", Value: EnumInterfaceType.AVAL },
        ];
        
        return (
            <div key={user.id}>
                <h2>Benutzer bearbeiten</h2>
                <Card Name="Kopfdaten" Label="Kopfdaten">
                    <Input<string>
                        {...modul.bind('username')}
                        Label="Nutzername"
                        Required
                    />
                    <Input<string>
                        {...modul.bind('email')}
                        Label="Email"
                        type="email"
                    />

                    <CheckBox
                        {...modul.bind('isDavid')}
                        Label="David/Clearo"
                    />
                    
                    <Select
                        Name="Interfaces"
                        Label="Schnittstellen"
                        Items={interfaces}
                        value={user.interfaces[0]}
                        onChange={(v: number) => user.interfaces = [+v]}
                        Required
                    />
                </Card>
                <Card Name="AuthData" Label="Login-Daten">
                    <Input<string>
                        Label="ID"
                        value={user.id}
                        locked
                    />
                    <Input<string>
                        {...modul.bind('password')}
                        Label="Passwort"
                        locked={!New}
                    />
                    <Input<string>
                        Label="Client Secret"
                        value={user.client_secret}
                        Multiple
                        locked
                    />
                </Card>
                <Footer
                    New
                    onSave={() => modul.onLeave(1, user)}
                    onCancel={() => modul.onLeave(2, user)}
                    onDelete={() => false}
                />
            </div>
        );
    }
}